import { getAPI, putAPI } from './api-service'

export const loadResponsesAPI = async ({ surveyName }) => {
  return await getAPI('SurveyAPI', `/surveys/${surveyName}/responses`)
}

export const updateResponseAPI = async ({
  surveyName,
  categoryName,
  params
}) => {
  const body = { body: { ...params } }
  return await putAPI(
    'SurveyAPI',
    `/surveys/${surveyName}/${categoryName}`,
    body
  )
}
